import { Component, Input } from '@angular/core';

@Component({
    selector: 'agpr-form-message',
    templateUrl: './form-message.component.html',
    styleUrls: ['./form-message.component.scss'],
    standalone: false
})
export class FormMessageComponent {
    @Input() id: string = '';
    @Input() marginBottom: number = 10;
}
/**
 * This component could be modified in the future to support multiple modes (like MessageComponent),
 * closeability & id-ing, icon-overrides, etc.
 */
